/**
 * Swatch Hover Fix - Implements the same working swatch logic from product cards
 * This script replicates the proven swatch hover functionality for the main product page
 */

(function() {
  'use strict';
  
  console.log('Swatch Hover Fix: Initializing');
  
  // Replicate the working swatch logic from product cards
  function initializeSwatchesOnProductPage() {
    const productForm = document.querySelector('product-form-component');
    if (!productForm) return;
    
    const variantPicker = productForm.querySelector('variant-picker');
    if (!variantPicker) return;
    
    const variantIdInput = productForm.querySelector('input[name="id"]');
    if (!variantIdInput) return;
    
    console.log('Swatch Hover Fix: Found product form elements');
    
    // Build availability map from swatches' data attributes (same as working logic)
    const availabilityMap = {};
    const swatches = variantPicker.querySelectorAll('input[data-variant-id]');
    
    swatches.forEach(function(swatch) {
      const vId = swatch.getAttribute('data-variant-id');
      const avail = swatch.getAttribute('data-option-available') === 'true';
      if (vId) {
        availabilityMap[vId] = avail;
      }
    });
    
    console.log('Swatch Hover Fix: Availability map:', availabilityMap);
    
    // Helper: update variant ID input for a given variant ID (same as working logic)
    function updateVariantId(variantId) {
      console.log('Swatch Hover Fix: Updating variant ID to:', variantId);
      
      if (variantIdInput) {
        variantIdInput.value = variantId;
        // Force change event to notify other listeners
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        variantIdInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      
      // Update add to cart button state
      const addToCartButton = productForm.querySelector('button[type="submit"], .add-to-cart-button');
      if (addToCartButton) {
        const isAvailable = availabilityMap.hasOwnProperty(variantId) ? availabilityMap[variantId] : true;
        addToCartButton.disabled = !isAvailable;
        addToCartButton.style.opacity = isAvailable ? '1' : '0.4';
        console.log('Swatch Hover Fix: Updated button availability:', isAvailable);
      }
    }
    
    // 1) Initialize to default variant on load (same as working logic)
    const defaultVariant = variantIdInput.value;
    if (defaultVariant) {
      console.log('Swatch Hover Fix: Initializing with default variant:', defaultVariant);
      updateVariantId(defaultVariant);
    }
    
    // 2) Swatch hover → update selected variant (same as working logic)
    swatches.forEach(function(swatch) {
      swatch.addEventListener('mouseenter', function() {
        const vId = this.getAttribute('data-variant-id');
        console.log('Swatch Hover Fix: Swatch hovered, variant ID:', vId);
        
        if (vId) {
          // Store the selected variant on the form for later use
          productForm.setAttribute('data-selected-variant', vId);
          productForm.setAttribute('data-selected-available', availabilityMap[vId]);
          
          // Update the variant ID immediately
          updateVariantId(vId);
        }
      });
      
      // Also handle click events
      swatch.addEventListener('click', function() {
        const vId = this.getAttribute('data-variant-id');
        console.log('Swatch Hover Fix: Swatch clicked, variant ID:', vId);
        
        if (vId) {
          // Store the selected variant on the form for later use
          productForm.setAttribute('data-selected-variant', vId);
          productForm.setAttribute('data-selected-available', availabilityMap[vId]);
          
          // Update the variant ID immediately
          updateVariantId(vId);
        }
      });
    });
    
    // 3) Override form submission to ensure correct variant ID (same as working logic)
    const form = productForm.querySelector('form');
    if (form) {
      form.addEventListener('submit', function(event) {
        const selectedVariant = productForm.getAttribute('data-selected-variant');
        console.log('Swatch Hover Fix: Form submission, selected variant:', selectedVariant);
        
        if (selectedVariant && variantIdInput.value !== selectedVariant) {
          console.log('Swatch Hover Fix: Updating variant ID before submission');
          variantIdInput.value = selectedVariant;
        }
      });
    }
    
    console.log('Swatch Hover Fix: Initialized successfully');
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSwatchesOnProductPage);
  } else {
    initializeSwatchesOnProductPage();
  }
  
  // Also watch for dynamic content changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        
        // Check if a new product form was added
        if (node.matches && node.matches('product-form-component')) {
          console.log('Swatch Hover Fix: New product form detected');
          setTimeout(initializeSwatchesOnProductPage, 100);
        }
        
        // Check if the node contains product forms
        if (node.querySelectorAll) {
          const productForms = node.querySelectorAll('product-form-component');
          if (productForms.length > 0) {
            console.log('Swatch Hover Fix: New product forms detected');
            setTimeout(initializeSwatchesOnProductPage, 100);
          }
        }
      });
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  console.log('Swatch Hover Fix: Monitoring for dynamic content');
  
})();
